import { withoutKey } from './utils.js';
export const applyIdentifiers = (identifiers) => (state) => {
    const clientIdentifiers = identifiers;
    return { ...state, clientIdentifiers };
};
export const withoutIdentifiers = withoutKey('clientIdentifiers');
export const selectIdentifiers = (state) => state.clientIdentifiers;
